export const CLUB_CREATING_FEE = 0.02975;
export const ADD_MEMBER_FEE = 0.00175;
export const CREATE_FUNDRAISE_FEE = 0.00174;
export const CREATE_DISCUSSION_PROPOSAL_FEE = 0.0062;
export const CREATE_BUY_PROPOSAL_FEE = 0.0094;
export const CREATE_SELL_PROPOSAL_FEE = 0.0176;
export const CREATE_WITHDRAWAL_PROPOSAL_FEE = 0.01846;
export const CREATE_TRANSFER_PROPOSAL_FEE = 0.00688148;
export const ADD_MEMBER_EXISTING_CLUB_FEE = 0.0018;
export const DEPOSIT_FEE = 0.0122;
export const VOTE_WITH_NFT_FEE = 0.00313004;
export const SOLANA_FEE = 0.05;
export const EXECUTE_WITHDRAWAL_FEE = 0.00295104;
export const DEPOSIT_STAKING_TOKENS_FEE = 0.0013622;
export const DEPOSIT_STAKING_NFT_FEE = 0.00204428;
//TODO@milica@guta: we already calculated potential token ledger initializaton, think about optimizing this
export const EXECUTE_TRANSFER_PROPOSAL = 0.00615264;
export const TREASURY_RENT = 0.00089088;
export const CREATE_UPDATE_GOVERNANCE_CONFIG_FEE =
  0.00695108 + 0.000005 + 0.00791852;
